module.exports = "/assets/data/823bcb6c121d8cf0fc9984aa6f260ada-AB51.data.json";